export type CancelStep = 'Cancellation Settings' | 'Reservation Handling' | 'Review';

export type ReservationChoice = 'KEEP' | 'DELETE';

export const ALL_CANCEL_STEPS: CancelStep[] = ['Cancellation Settings', 'Reservation Handling', 'Review'];
